import { httpClient, HttpClient } from "./HTTPService";
import { store } from "../index";
import { ISearchRequest, ISuggestion } from "../../models/Search";
import qs from "qs";
import { IReqCybersecurityObjects } from "../../models/CybersecurityObject";
import { CyberSecurityResponse } from "../../models/CurrentCybersecurityObject";
import { ICybersecurityInfoState } from "../reducers/_maps/cyberSecurity/cybersecurity/types";
import i18n from "../../i18n";
import { AxiosResponse } from "axios";

const token = store.getState().auth.token.access;

class CybersecurityService {
  constructor(private httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  private getLocale() {
    return i18n.language === "ua" ? "uk" : "en";
  }

  public async fetchCybersecurityList(data: IReqCybersecurityObjects) {
    try {
      return this.httpClient.get<ICybersecurityInfoState>(
        `cyber_security/${this.getLocale()}/${data.account_id}/`,
        {
          params: data,
          paramsSerializer: (params) => {
            return qs.stringify(params, { indices: false });
          },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async getById(
    RECORD: string,
    account_id: number
  ): Promise<AxiosResponse<CyberSecurityResponse>> {
    if (RECORD) {
      return this.httpClient.get<CyberSecurityResponse>(
        `cyber_security/${this.getLocale()}/${account_id}/${RECORD}/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    } else return undefined;
  }

  public async fetchSuggestions(data: ISearchRequest) {
    return this.httpClient.post<ISuggestion[]>(
      `cyber_security/${this.getLocale()}/${data["account_id"]}/suggest/`,
      data,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  }
}

export const cybersecurityService = new CybersecurityService(httpClient);
